import SearchBox from "../components/SearchBox";
import ResultsPageSubHeader from "../components/ResultsPageSubHeader";
import FilterDesktop from "../components/FilterDesktop";
import { Link } from "react-router-dom";
import { T } from "@tolgee/react";
import ResultsDisplay from "../components/ResultsDisplay";
import LoadingIndicator from "../components/LoadingIndicator";
import { useFilter } from "../hooks/useFilter";
import useAppState from "../store/appState";
import Overlay from "../components/Overlay";
import CompanySelection from "../components/CompanySelection";

function ResultsPage() {
  const { displayMobileFilterModal } = useAppState();
  const { materials, activeFilters, setActiveFilters, categories, isFetching, sortby, setSortby, companies, data, defaultCountry, vectorSearch, setVectorSearch } = useFilter();

  return (
    <div className="bg-white">
      {displayMobileFilterModal && <Overlay activeFilters={activeFilters} setActiveFilters={setActiveFilters} categories={categories} materials={materials} data={data} />}
      <ResultsPageSubHeader />

      <section className=" mx-4 lg:ml-[114px] lg:mr-[115px] mt-[19px] mb-[30px] lg:mb-[10px]  lg:mt-[46px] ">
        <p className="lg:hidden mb-[19px] text-grey-4 ">
          <Link className="text-grey-1-sp underline decoration-1 underline-offset-2 font-semibold" to="/" rel="noopener noreferrer">
            <T keyName="ResultsPage.breadcrumb.homepage-link" />
          </Link>
          &nbsp;/&nbsp;
          <T keyName="ResultsPage.breadcrumb.results" />
        </p>
        <div className="flex mb-[28px] lg:mb-[34px] ">
          <SearchBox />
          {companies && (
            <>
              <CompanySelection companies={companies} />
              <label className="w-full flex items-center my-2">
                <input
                  className=" mr-2 accent-black peer relative appearance-none shrink-0 w-5 h-5 border-2 border-black rounded-md ml-1 bg-white focus:outline-none focus:ring-offset-0 focus:ring-1 focus:ring-blue-100 checked:bg-white checked:border-black"
                  type="checkbox"
                  onChange={(e) => setVectorSearch(e.target.checked)}
                />
                <svg
                  className="absolute p-1  w-5 h-5 pointer-events-none hidden peer-checked:block stroke-black ml-1  outline-none"
                  width="12"
                  height="10"
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 7.64331L1.41 9L8 2.70382L10.58 5.15924L12 3.8121L8 7.37351e-08L0 7.64331Z" fill="black" />
                </svg>
                <p className="font-inter leading-[18px] text-[14px] font-normal">Use vector search</p>
              </label>
            </>
          )}
        </div>
        {!isFetching && materials && (
          <div className="grid gap-0 lg:gap-[102px] grid-cols-[0_1fr] lg:grid-cols-[304px_1fr] mb-[80px]">
            <div className="overflow-hidden ">
              <div className="hidden lg:block">
                <FilterDesktop activeFilters={activeFilters} setActiveFilters={setActiveFilters} categories={categories} materials={materials} allMaterials={data} />
              </div>
            </div>
            <div className="col-start-2">
              <ResultsDisplay materials={materials} activeFilters={activeFilters} sortby={sortby} setSortby={setSortby} defaultCountry={defaultCountry} />
            </div>
          </div>
        )}
      </section>

      <div className="flex flex-col  text-center font-inter leading-[28px] text-[18px] lg:leading-[24px] lg:text-[16px] font-semibold">
        {isFetching && (
          <div className="h-[25vh]">
            <LoadingIndicator />
          </div>
        )}

        {!isFetching && !materials && (
          <div className="h-[25vh]">
            <T keyName="ResultsPage.p.no-results-found" />
          </div>
        )}
      </div>
    </div>
  );
}

export default ResultsPage;
